import { render, staticRenderFns } from "./loginPageConfiguration.vue?vue&type=template&id=456be3d7&scoped=true"
import script from "./loginPageConfiguration.vue?vue&type=script&lang=js"
export * from "./loginPageConfiguration.vue?vue&type=script&lang=js"
import style0 from "./loginPageConfiguration.vue?vue&type=style&index=0&id=456be3d7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456be3d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456be3d7')) {
      api.createRecord('456be3d7', component.options)
    } else {
      api.reload('456be3d7', component.options)
    }
    module.hot.accept("./loginPageConfiguration.vue?vue&type=template&id=456be3d7&scoped=true", function () {
      api.rerender('456be3d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/loginPageConfiguration.vue"
export default component.exports